<script setup>

</script>

<template>
	<div class="bg-white shadow sm:rounded-lg">
		<div class="px-4 py-5 sm:p-6 mb-4">
			<div class="flex">
				<h3 class="text-base font-semibold leading-6 text-gray-900">Personal Team</h3>

			</div>


			<div class="mt-2 sm:flex sm:items-start sm:justify-between">
				<div class="max-w-xl text-sm text-gray-500">
					<p>You are currently using SlideCub as an individual user on a personal team. You are free to create or join additional teams. Be advised that all teams, including personal ones are billed separately. </p>
				</div>
				<div class="mt-5 sm:ml-6 sm:mt-0 sm:flex sm:flex-shrink-0 sm:items-center">
<!--					<Link href="/billing" type="button" class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500">Access Billing Portal</Link>-->
				</div>
			</div>
		</div>
	</div>
</template>
